import type { FunMedia } from 'components/fun'

type MediaConfig = FunMedia

const PRE_API_MEDIA: MediaConfig[] = [
  {
    src: 'https://media.giphy.com/media/DQH6hztBt84ASCylzH/giphy.gif',
    alt: 'Lights out / départ de course',
    caption: 'Feux rouges… prêt au départ 🟥🟥🟥',
  },
  {
    src: 'https://media.giphy.com/media/zDqOVXOyHtpL6kUtit/giphy.gif',
    alt: 'F1 lights out',
    caption: 'Extinction des feux imminente… 🏁',
  },
  {
    src: 'https://media.giphy.com/media/62NjG2TNZuiWYPihvI/giphy.gif',
    alt: 'Rally start',
    caption: 'Top départ !',
  },
  {
    src: 'https://media.giphy.com/media/335gBk7Y4Dlb719zj2/giphy.gif',
    alt: 'Rally take off',
    caption: 'GO ! 🚦',
  },
]

const RANDOM_MEDIA_POOL: MediaConfig[] = [
  {
    src: 'https://media.giphy.com/media/Iej9tNgPGfa1ZywikN/giphy.gif',
    alt: 'Voiture drifting',
    caption: 'On négocie la trajectoire… 😅',
  },
  {
    src: 'https://media.giphy.com/media/RYTIJ5D8HV7qmmCH3d/giphy.gif',
    alt: 'Rallye / drift',
    caption: 'Traitement à pleine vitesse… 🏁',
  },
  {
    src: 'https://media.giphy.com/media/USQldFTYp0CFd2wmrc/giphy.gif',
    alt: 'Tokyo drift',
    caption: 'On prend la bretelle de sortie… 🔄',
  },
  {
    src: 'https://media.giphy.com/media/li4Zrg75cjTZm/giphy.gif',
    alt: 'Cars (Pixar) course',
    caption: 'Export en mode Flash McQueen ⚡',
  },
  {
    src: 'https://media.giphy.com/media/cmOQHlIpMMHECCW6Nk/giphy.gif',
    alt: 'Mécanicien / cric',
    caption: 'Petit check-up avant livraison… 🛠️',
  },
  {
    src: 'https://media.giphy.com/media/H2sSMLo3D5ShOm2qEJ/giphy.gif',
    alt: 'Réparation voiture',
    caption: 'On règle deux-trois bricoles… 🧪',
  },
  {
    src: 'https://media.giphy.com/media/0k6feXtzBoMrXVgyP8/giphy.gif',
    alt: 'Drag racing',
    caption: 'Ça accélère côté export… 🚀',
  },
  {
    src: 'https://media.giphy.com/media/Ta7jkLAHZ2CvzJpuis/giphy.gif',
    alt: 'Drag racing (top fuel)',
    caption: 'On pousse la machine… 💥',
  },
  {
    src: 'https://media.giphy.com/media/YlCYJEf332qbP07hKb/giphy.gif',
    alt: 'Funny car “Number 1”',
    caption: 'Objectif : P1 sur la ligne d’arrivée 🥇',
  },
]

const shuffleMedia = <T,>(input: T[]) => {
  const arr = [...input]
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1))
    const tmp = arr[i]
    arr[i] = arr[j]
    arr[j] = tmp
  }
  return arr
}

const getFallbackMedia = (hasFirstResponse: boolean): FunMedia =>
  hasFirstResponse ? RANDOM_MEDIA_POOL[0] : PRE_API_MEDIA[0]

export { PRE_API_MEDIA, RANDOM_MEDIA_POOL, shuffleMedia, getFallbackMedia }
